import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const image = require('img/logo/logo.png'); // eslint-disable-line

export default class Logo extends Component {
  render() {
    const { link } = this.props;


    if (link) {
      return (
        <Link to={link} className="logo__link">
          {this.renderImage()}
        </Link>
      );
    }

    return this.renderImage();
  }

  renderImage() {
    const { alt, src, size } = this.props;
    const className = `logo logo--${size}`;

    return (
      <div className={className}>
        <img className="logo__img" src={src} alt={alt} />
      </div>
    );
  }
}

Logo.defaultProps = {
  alt: 'Remeha',
  size: 'sm',
  src: image,
};

Logo.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  link: PropTypes.string,
  size: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/logo/index.jsx